// The LIVE customer-facing inventory app domain attached to the
// stormtech-inventory-frontend Vercel project (naming decision 2026-07-07,
// same probe-Vercel-not-docs verification as v2Portal.js).
const DEFAULT_INVENTORY_PUBLIC_URL = "https://inventory.stormtechperformance.com";

/**
 * Base URL of the V2 customer-facing inventory app. Baked at build time from
 * REACT_APP_INVENTORY_PUBLIC_URL (.env.production / .env.staging); the
 * fallback keeps production builds correct if the var is ever missing.
 */
export function getInventoryPublicUrl() {
  const configured = process.env.REACT_APP_INVENTORY_PUBLIC_URL;
  const base = (configured && configured.trim()) || DEFAULT_INVENTORY_PUBLIC_URL;
  return base.replace(/\/$/, "");
}

/**
 * Customer share URL for a V2 collection (the inventory app serves shares at
 * /share/:linkId).
 */
export function getV2ShareUrl(shareLinkId) {
  return `${getInventoryPublicUrl()}/share/${shareLinkId}`;
}
